// LumiR: echte Kundenaktion merken. Der Warenkorb darf sich nur nach einem echten Klick / Tippen /
// Tastendruck öffnen – nie automatisch beim Laden, nach Neuladen, im Theme-Editor oder durch Skripte.
(function () {
  if (window.__lrUserAction) return;
  window.__lrUserAction = { t: 0 };
  ["pointerdown", "touchstart", "keydown", "click"].forEach((type) =>
    document.addEventListener(
      type,
      (evt) => {
        if (evt.isTrusted) window.__lrUserAction.t = Date.now();
      },
      true
    )
  );
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // LumiR: Startzustand ist immer GESCHLOSSEN (auch im Theme-Editor und nach dem Neuladen).
    this.classList.remove("active", "animate");
    this.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    // LumiR: robustes Schließen – Klick auf den dunklen Hintergrund (auch nach Neuladen des Inhalts),
    // Escape von überall, und Zustand (aria-hidden / Scroll-Sperre) immer synchron halten.
    this.addEventListener(
      "click",
      (evt) => {
        if (!this.classList.contains("active")) return;
        const t = evt.target;
        if (t === this || t.id === "CartDrawer-Overlay" || t.id === "CartDrawer") this.close();
      },
      true
    );
    document.addEventListener("keydown", (evt) => {
      if ((evt.key === "Escape" || evt.key === "Esc") && this.classList.contains("active")) this.close();
    });
    if (!this.classList.contains("active")) this.setAttribute("aria-hidden", "true");
    this._lrWasOpen = this.classList.contains("active");
    new MutationObserver(() => {
      const isOpen = this.classList.contains("active");
      if (isOpen === this._lrWasOpen) return;
      this._lrWasOpen = isOpen;
      if (isOpen) {
        this.removeAttribute("aria-hidden");
        this.setCartIconExpanded(true);
      } else {
        this.setAttribute("aria-hidden", "true");
        this.setCartIconExpanded(false);
        this.unlockPage();
      }
    }).observe(this, { attributes: true, attributeFilter: ["class"] });
  }

  userInitiated() {
    // Öffnen nur, wenn kurz zuvor eine echte Kundenaktion stattfand
    // (Warenkorb-Symbol oder „In den Warenkorb“ inkl. Ladezeit der Anfrage).
    const ua = window.__lrUserAction;
    return !!(ua && ua.t && Date.now() - ua.t < 20000);
  }

  setCartIconExpanded(isOpen) {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (cartLink) cartLink.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  unlockPage() {
    document.body.classList.remove("overflow-hidden");
    document.documentElement.classList.remove("overflow-hidden");
    document.body.style.removeProperty("overflow");
    document.documentElement.style.removeProperty("overflow");
    const main = document.getElementById("MainContent");
    if (main) {
      main.removeAttribute("inert");
      main.removeAttribute("aria-hidden");
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.setAttribute("aria-expanded", "false");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // LumiR: kein automatisches Öffnen ohne echte Kundenaktion
    if (!this.userInitiated()) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.removeAttribute("aria-hidden");
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      // Dispatch cart:open event
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    this.setCartIconExpanded(false);
    this.setAttribute("aria-hidden", "true");
    try {
      removeTrapFocus(this.activeElement);
    } catch (e) {}
    this.unlockPage();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
